import { NgModule } from '@angular/core';
import { NgxFullpageGoToLastDirective } from './just-fullpage-go-to-last/ngx-fullpage-go-to-last.directive';



@NgModule({
  declarations: [NgxFullpageGoToLastDirective],
  imports: [],
  exports: [NgxFullpageGoToLastDirective]
})
export class NgxFullpageGoToLastModule { }
